const baseUrl = process.env.REACT_APP_BASE_URL;
const frontendUrl = process.env.REACT_APP_FRONTEND_URL;

export { frontendUrl };
export default baseUrl;
